const {KitModule, registerModule, Flickity} = window;

// Add and remove a resizing class to get equal height cells
const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

class PostList extends KitModule {
  constructor($element) {
    super($element);

    if (this.$carousel) {
      // The carousel is only rendered if there are more than two items, so we
      // shouldn't attempt to initialize Flickity or related elements if it
      // doesn't exist.
      this.initFlickity();
    }
  }

  initFlickity() {
    this.flkty = new Flickity(this.$carousel, {
      freeScroll: true,
      freeScrollFriction: 0.1,
      imagesLoaded: true,
      cellAlign: 'left',
      contain: false,
      pageDots: false,
      prevNextButtons: false,
    });

    // Recalc position from unhide/lazy load
    window.addEventListener('load', () => {
      this.flkty.reloadCells();
      this.flkty.resize();
    });

    // custom prev/next
    this.$previousBtn.addEventListener('click', () => this.flkty.previous());
    this.$nextBtn.addEventListener('click', () => this.flkty.next());

    // progress dots update on select
    // update prev/next buttons
    this.flkty.on('select', (index) => {
      [...this.$pageDots.children].forEach(($dot) => {
        $dot.classList.remove('is-selected');
      });
      this.$pageDots.querySelector(`[data-index="${index}"]`).classList.add('is-selected');

      // disabled if first / last
      if (!this.flkty.cells[this.flkty.selectedIndex - 1]) {
        this.$nextBtn.removeAttribute('disabled');
        this.$previousBtn.setAttribute('disabled', 'disabled');
      } else if (this.flkty.cells[this.flkty.selectedIndex + 1]) {
        this.$previousBtn.removeAttribute('disabled');
        this.$nextBtn.removeAttribute('disabled');
      } else {
        this.$previousBtn.removeAttribute('disabled');
        this.$nextBtn.setAttribute('disabled', 'disabled');
      }
    });

    // Update status
    this.flkty.on('change', () => {
      const cellNumber = this.flkty.selectedIndex + 1;
      this.$status.innerText = cellNumber;
    });
  }

  unmount() {
    this.flkty.destroy();
  }
}

registerModule('PostList', PostList);
